import { Modal } from '@consta/uikit/Modal';
import { Header } from '@components/ui/layout/modal/components';
import { Button } from '@components/ui/base/button';
import { TextInput } from '@components/ui/base/text-input';
import cn from 'classnames';
import { useModalQueue } from '@src/hooks';
import { useEffect, useMemo, useState } from 'react';
// import { FileService } from '@api/actions/file';

export const RenameFile = ({ setIsShow, className, container, title, file, onFileRename }: any) => {
    const closeModalHandler = useModalQueue(setIsShow);
    const [fileName, setFileName] = useState(file.name.split('.').slice(0, -1).join('.'));
    const extension = useMemo(() => file.name.split('.').pop(), [file.name]);
    const [modalContainer, setModalContainer] = useState<HTMLDivElement | undefined>(container);

    const renameFile = async () => {
        onFileRename(`${fileName}.${extension}`);
        closeModalHandler();
    };

    useEffect(() => {
        setModalContainer(container || (document.getElementById('MainLayout') as HTMLDivElement));
    }, []);

    return (
        <Modal
            isOpen={true}
            hasOverlay={true}
            onClickOutside={(e: any) => {
                if (!e.target.closest('.dhx_popup')) {
                    closeModalHandler();
                }
            }}
            position="center"
            onEsc={closeModalHandler}
            className={cn('rename-file-modal grid w-[60.0179vmin]', className)}
            container={modalContainer}
        >
            <div className="rename-file-modal_container flex flex-col h-full p-[3.1756vmin] ">
                <Header title={title} closeBtnClickHandler={() => closeModalHandler()} />

                <TextInput
                    value={fileName}
                    focused={true}
                    onFocus={(e: any) => e.target.select()}
                    onChange={(newName: any) => setFileName(newName)}
                />

                <div className="flex flex-row w-full justify-between items-end flex-1 h-full">
                    <div>
                        <Button
                            className="mr-[0.8468vmin] text-[1.482vmin]"
                            label="Сохранить"
                            onClick={() => renameFile()}
                            view="primary"
                        />

                        <Button
                            className="text-[1.482vmin]"
                            label="Закрыть"
                            onClick={() => closeModalHandler()}
                            view="ghost"
                        />
                    </div>
                </div>
            </div>
        </Modal>
    );
};
